var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Input',{attrs:{"user":_vm.user},on:{"create-comment":_vm.createComment}}),_c('Comments',{attrs:{"comments":_vm.comments,"loading":_vm.commentsLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }